import React from 'react';
import theme from './CommentListEventItem.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { InternalLinkButton } from '@/components/Buttons';
import { TranslatableText } from '@/types';

interface CommentListEventItemProps {
    title: TranslatableText;
    icon: IconProp;
    topText: TranslatableText;
    bottomText?: TranslatableText;
    buttonText?: TranslatableText;
    url?: string;
}

export const CommentListEventItem: React.FC<CommentListEventItemProps> = ({
    title,
    icon,
    topText,
    bottomText,
    buttonText,
    url,
}) => {
    const showBottomPart = !!(bottomText || url);

    return (
        <div className={theme.container}>
            <div className={theme.top}>
                <div className={theme.left}>
                    <FontAwesomeIcon icon={icon} />
                </div>
                <div className={theme.right}>
                    <div className={theme.title}>{title}</div>
                    <div className={theme.text}>{topText}</div>
                </div>
            </div>
            {showBottomPart && (
                <div className={theme.bottom}>
                    <div className={theme.offerSentText}>{bottomText}</div>
                    {!!url && (
                        <InternalLinkButton className={theme.button} color={'tertiary'} to={url}>
                            {buttonText}
                        </InternalLinkButton>
                    )}
                </div>
            )}
        </div>
    );
};